<template>
  <div class="container">
    <header class="jumbotron">
      <h1>{{ team }}</h1>
      <div>
        ({{ selected && selected.length }} deltakere)
      </div>
    </header>
    <div class="list row">
      <div class="col-md-6">
        <table>
          <tr>
            <td>Antall utøvere:</td>
            <td><span>{{ this.selected && this.selected.length }}</span></td>
          </tr>
          <tr>
            <td>Utøvere med tidligere opprop</td>
            <td><span>{{ this.content.passed && this.content.passed.length }}</span></td>
          </tr>
          <tr>
            <td>Utøvere med manglende opprop senere i dag</td>
            <td><span>{{ this.content.latertoday_callroom_missing &&
              this.content.latertoday_callroom_missing.length }}</span></td>
          </tr>
          <tr>
            <td>
              <ul class="list-group">
                <li class="list-group-item" :class="{ active: index == currentIndex }"
                  v-for="(participant, index) in this.content.latertoday_callroom_missing" :key="index" @click="setActiveTeam(participant, index)">
                  <div>
                    {{ participant.participant_bib }} - {{ participant.participant_name }} <small hidden="hidden">(Id:{{
                      participant.participant_id }})</small> - {{ participant.participant_team }}
                  </div>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>Utøvere med trukket opprop senere i dag</td>
            <td><span>{{ this.content.latertoday_callroom_negative &&
              this.content.latertoday_callroom_negative.length }}</span></td>
          </tr>
          <tr>
            <td>
              <ul class="list-group">
                <li class="list-group-item" :class="{ active: index == currentIndex }"
                  v-for="(participant, index) in this.content.latertoday_callroom_negative" :key="index" @click="setActiveTeam(participant, index)">
                  <div>
                    {{ participant.participant_bib }} - {{ participant.participant_name }} <small hidden="hidden">(Id:{{
                      participant.participant_id }})</small> - {{ participant.participant_team }}
                  </div>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>Utøvere med opprop senere i dag</td>
            <td><span>{{ this.content.latertoday_callroom_ok && this.content.latertoday_callroom_ok.length }}</span></td>
          </tr>
          <tr>
            <td>Utøvere med manglende opprop etter i dag</td>
            <td><span>{{ this.content.future_callroom_missing && this.content.future_callroom_missing.length }}</span>
            </td>
          </tr>
          <tr>
            <td>Utøvere med trukket opprop etter i dag</td>
            <td><span>{{ this.content.future_callroom_negative && this.content.future_callroom_negative.length }}</span>
            </td>
          </tr>
          <tr>
            <td>Utøvere med opprop etter i dag</td>
            <td><span>{{ this.content.future_callroom_ok && this.content.future_callroom_ok.length }}</span></td>
          </tr>
        </table>
        <!-- <ul class="list-group">
          <li class="list-group-item" :class="{ active: index == currentIndex }" v-for="(participant, index) in selected"
            :key="index" @click="setActiveTeam(participant, index)">
            <div>
              {{ participant.participant_bib }} - {{ participant.participant_name }} <small hidden="hidden">(Id:{{
                participant.participant_id }})</small> - {{ participant.participant_team }}
              <a class="badge badge-success float-right" :href="'/team/' + encodeURIComponent(team)">
                Vis lag
              </a>
            </div>
          </li>
        </ul> -->
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '../services/user.service';

export default {
  name: 'Teams',
  data() {
    return {
      content: '',
      events: '',
      selected: '',
      team: '',
      currentTeam: null,
      currentIndex: -1,
      debug: false
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    console.log("BoardTeam - mounted");
    this.getData();
  },
  methods: {
    getEventData(competition_id) {
      UserService.getEventsBoard(competition_id).then(
        response => {
          var all = [];
          var passed = [];
          var current = [];
          var future = [];
          response.data.events.forEach(event => {
            all.push(event);
            if (this.isPassedTime(event.event_time)) {
              passed.push(event);
            } else {
              if (this.isPassedTime(event.callroomregistration_closed_time)) {
                if (new Date(event.callroomregistration_closed_time) < new Date("2020-01-01T01:00:00")) {
                  passed.push(event);
                } else {
                  current.push(event);
                }
              } else {
                future.push(event);
              }
            }
          });
          response.data.all = all || [];
          response.data.passed = passed || [];
          response.data.current = current || [];
          response.data.future = future || [];
          this.events = response.data;
        },
        error => {
          this.content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    getData() {
      let competition_id = this.$route.params.competition_id;
      console.log("competition_id");
      console.log(competition_id);
      this.getEventData(competition_id);
      if (this.$route.params.teamname) {
        this.team = decodeURIComponent(this.$route.params.teamname)
      }
      UserService.getParticipantsBoard(competition_id).then(
        response => {
          const uniqueSet = new Set();
          response.data.participants.forEach(item => {
            uniqueSet.add(item.participant_team);
          });
          response.data.teams = Array.from(uniqueSet);
          this.content = response.data;
          var selected = [];
          var arr_latertoday_callroom_missing = [];
          var arr_latertoday_callroom_negative = [];
          var arr_latertoday_callroom_ok = [];
          var arr_future_callroom_missing = [];
          var arr_future_callroom_negative = [];
          var arr_future_callroom_ok = [];
          var arr_passed = [];
          var all = [];
          var now = new Date();
          var latertoday_callroom_missing = 0;
          var latertoday_callroom_negative = 0;
          var latertoday_callroom_ok = 0;
          var future_callroom_missing = 0;
          var future_callroom_negative = 0;
          var future_callroom_ok = 0;
          var passed = 0;
          response.data.participants.forEach(participant => {
            if (participant.participant_team == this.team) {
              selected.push(participant)
              participant.events.forEach(event => {
                const foundevent = this.events.all.find(item => item.event_id === event.event_id)
                var event_time = new Date(foundevent.event_time);
                if (event_time > now) {
                  if (this.isSameDay(event_time, now)) {
                    if (event.callroomstatus == null) {
                      latertoday_callroom_missing++;
                    } else if (event.callroomstatus == false) {
                      latertoday_callroom_negative++;
                    } else if (event.callroomstatus) {
                      latertoday_callroom_ok++;
                    }
                  } else {
                    if (event.callroomstatus == null) {
                      future_callroom_missing++;
                    } else if (event.callroomstatus == false) {
                      future_callroom_negative++;
                    } else if (event.callroomstatus) {
                      future_callroom_ok++;
                    }
                  }
                } else {
                  passed++;
                }
              })
              all.push(participant);
              if (latertoday_callroom_missing) {
                arr_latertoday_callroom_missing.push(participant);
              }
              if (latertoday_callroom_negative) {
                arr_latertoday_callroom_negative.push(participant);
              }
              if (latertoday_callroom_ok) {
                arr_latertoday_callroom_ok.push(participant);
              }
              if (future_callroom_missing) {
                arr_future_callroom_missing.push(participant);
              }
              if (future_callroom_negative) {
                arr_future_callroom_negative.push(participant);
              }
              if (future_callroom_ok) {
                arr_future_callroom_ok.push(participant);
              }
              if (passed) {
                arr_passed.push(participant);
              }
            }
          });
          this.selected = selected;
          this.content.latertoday_callroom_missing = arr_latertoday_callroom_missing;
          this.content.latertoday_callroom_negative = arr_latertoday_callroom_negative;
          this.content.latertoday_callroom_ok = arr_latertoday_callroom_ok;
          this.content.future_callroom_missing = arr_future_callroom_missing;
          this.content.future_callroom_negative = arr_future_callroom_negative;
          this.content.future_callroom_ok = arr_future_callroom_ok;
          this.content.passed = arr_passed;
        },
        error => {
          this.content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      )
    },
    setActiveTeam(team, index) {
      this.currentTeam = team;
      this.currentIndex = index;
    },
    isPassedTime(time) {
      if (Date.parse(time) < Date.now()) {
        return true;
      } else {
        return false;
      }
    },
    isSameDay(date1, date2) {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      )
    }
  }
};
</script>
